import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { CancelButton } from './ui/cancel-button';
import { RotatingDeleteIcon } from './RotatingDeleteIcon';

type SuggestionNotFoundModalProps = {
  open: boolean;
  originalText: string;
  onOpenChange: (open: boolean) => void;
  onDismissSuggestion: () => void;
  t: (key: string) => string;
};

export const SuggestionNotFoundModal: React.FC<SuggestionNotFoundModalProps> = ({
  open,
  originalText,
  onOpenChange,
  onDismissSuggestion,
  t,
}) => {
  const message = t('suggestion_not_found_message').replace('{text}', originalText);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('suggestion_not_found_title')}</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <CancelButton onClick={() => onOpenChange(false)}>
            {t('cancel')}
          </CancelButton>
          <Button
            variant="destructive"
            dialogPrimary
            onClick={() => {
              onDismissSuggestion();
              onOpenChange(false);
            }}
            className="group inline-flex items-center gap-1.5"
          >
            <RotatingDeleteIcon />
            {t('suggestion_not_found_remove')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
